import Modal from 'components/modal';
import SendReplyMSG from 'components/modal/sendReplyMSG';
import ParticipatedCard from 'modules/myAdvertisment/myAdvertismentDetail/buttonActions/RregisteredOffersAuction/ParticipatedCard';
import React from 'react';
interface ChooseAcutionModalsProps {
  isSendMSGOpen: boolean;
  isOpenModalParticipated: boolean;
  chosedSugestionUser: IChosedSugestionUser;
  postTypes: string;
  is_saled: boolean;
  setIsSendMSGOpen: (isSendMSGOpen: boolean) => void;
  setisOpenModalParticipated: (isSendMSGOpen: boolean) => void;
  setChosedSugestionUser: (chosedSugestionUser: IChosedSugestionUser) => void;
}
const ChooseAcutionModals = ({
  chosedSugestionUser,
  isSendMSGOpen,
  postTypes,
  is_saled,
  isOpenModalParticipated,
  setIsSendMSGOpen,
  setChosedSugestionUser,
  setisOpenModalParticipated,
}: ChooseAcutionModalsProps) => {
  return (
    <>
      <Modal
        isOpen={isSendMSGOpen}
        setIsOpen={value => {
          setIsSendMSGOpen(value);
          setChosedSugestionUser({
            ...chosedSugestionUser,
            profile: null,
          });
        }}
      >
        <SendReplyMSG
          post={chosedSugestionUser.guid ? chosedSugestionUser.guid : ''}
          post_type={postTypes}
          profile_type={
            chosedSugestionUser.type ? chosedSugestionUser.type : ''
          }
          setIsOpen={value => {
            setIsSendMSGOpen(value);
            setChosedSugestionUser({
              ...chosedSugestionUser,
              profile: null,
            });
          }}
        />
      </Modal>

      <Modal
        isOpen={isOpenModalParticipated}
        setIsOpen={value => {
          setisOpenModalParticipated(value);
          setChosedSugestionUser({
            ...chosedSugestionUser,
            profile: null,
          });
        }}
      >
        <ParticipatedCard
          isDelete={chosedSugestionUser.isDelete}
          is_saled={is_saled}
          cardType="auction"
          guid={
            chosedSugestionUser.profile?.guid
              ? chosedSugestionUser.profile?.guid
              : ''
          }
          name={
            chosedSugestionUser.profile?.profile?.name
              ? chosedSugestionUser.profile?.profile?.name
              : ''
          }
          image={
            chosedSugestionUser.profile?.profile?.profile_image
              ? chosedSugestionUser.profile?.profile?.profile_image
              : ''
          }
          participated_auctions={
            chosedSugestionUser.profile?.profile?.participated_auctions
              ? chosedSugestionUser.profile?.profile?.participated_auctions
              : 0
          }
          setIsOpenModal={value => {
            setisOpenModalParticipated(value);
            setChosedSugestionUser({
              ...chosedSugestionUser,
              profile: null,
            });
          }}
        />
      </Modal>
    </>
  );
};

export default ChooseAcutionModals;
